import { render, staticRenderFns } from "./layoutPage.vue?vue&type=template&id=fe10a084&scoped=true"
import script from "./layoutPage.vue?vue&type=script&lang=js"
export * from "./layoutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe10a084",
  null
  
)

export default component.exports